import { Signup4Component } from './signup4/signup4.component';
import { Signup3Component } from './signup3/signup3.component';
import { Signup2Component } from './signup2/signup2.component';
import { Routes } from "@angular/router";

import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { NewPasswordComponent } from "./new-password/new-password.component";
import { LockscreenComponent } from "./lockscreen/lockscreen.component";
import { SigninComponent } from "./signin/signin.component";
import { SignupComponent } from "./signup/signup.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { ErrorComponent } from "./error/error.component";
import { Signin3Component } from './signin3/signin3.component';
import { Signin4Component } from './signin4/signin4.component';
import { Signin2Component } from './signin2/signin2.component';
import { CompanySignupComponent } from './company-signup/company-signup.component';
import { CompanySigninComponent } from './company-signin/company-signin.component';
import { DomainCheckGuard } from '../../shared/services/domain.check.guard';
import {SessionsUserGuard} from "../../shared/guards/sessions-user.guard";
import {SessionsCompanyGuard} from "../../shared/guards/sessions-company.guard";
import {UserLoginGuard} from "../../shared/guards/user-login.guard";
import {ForbiddenComponent} from "./forbidden/forbidden.component";

export const SessionsRoutes: Routes = [
  {
    path: "",
    children: [
      // {
      //   path: "signup2",
      //   component: Signup2Component,
      //   data: { title: "Signup2" }
      // },
      // {
      //   path: "signin2",
      //   component: Signin2Component,
      //   data: { title: "Signin2" }
      // },
      // {
      //   path: "signup3",
      //   component: Signup3Component,
      //   data: { title: "Signup3" }
      // },
      // {
      //   path: "signin3",
      //   component: Signin3Component,
      //   data: { title: "sign-in-3" }
      // },
      // {
      //   path: "signup4",
      //   component: Signup4Component,
      //   data: { title: "Signup4" }
      // },
      // {
      //   path: "signin4",
      //   component: Signin4Component,
      //   data: { title: "Signin4" }
      // },
      {
        path: "lockscreen",
        component: LockscreenComponent,
        data: { title: "Lockscreen" }
      },
      {
        path: "403",
        component: ForbiddenComponent,
        data: { title: "Forbidden" }
      },
      {
        path: "404",
        component: NotFoundComponent,
        data: { title: "Not Found" }
      },
      {
        path: "error",
        component: ErrorComponent,
        data: { title: "Error" }
      },
      {
        path: "signup",
        component: CompanySignupComponent,
        data: { title: "Organization sign up" },
        canActivate: [SessionsCompanyGuard]
      },
      {
        path: "signin",
        component: CompanySigninComponent,
        data: { title: "Organization sign in" },
        canActivate: [SessionsCompanyGuard]
      },
      {
        path: 'user',
        canActivate: [SessionsUserGuard, UserLoginGuard],
        children: [
            {
              path: "signup",
              component: SignupComponent,
              data: { title: "Signup" },
            },
            {
              path: "signin",
              component: SigninComponent,
              data: { title: "Signin" },
            },
            {
              path: "forgot-password",
              component: ForgotPasswordComponent,
              data: { title: "Forgot password" },
            },
            {
              path: "new-password",
              component: NewPasswordComponent,
              data: { title: "New password" },
            },
        ]
      },

      //  For Legacy support
      {
        path: 'signup_user',
        redirectTo: 'user/signup'
      },
      {
        path: 'signin_user',
        redirectTo: 'user/signin'
      },
      {
        path: 'forgot-password',
        redirectTo: 'user/forgot-password'
      },
      {
        path: 'new-password',
        redirectTo: 'user/new-password'
      }
    ]
  }
];
